<template><div v-show="visible" :class="['collapse', visible && 'show']"><slot></slot></div></template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({ name: 'BCollapse', props: { visible: Boolean } })
</script>
